import axios from "axios";

const rawBackendUrl = process.env.REACT_APP_BACKEND_URL;
const normalizedBackendUrl =
  typeof rawBackendUrl === "string" && /^https?:\/\//i.test(rawBackendUrl)
    ? rawBackendUrl.replace(/\/+$/, "")
    : "";

const fallbackOrigin = typeof window !== "undefined" ? window.location.origin : "";
const BACKEND_URL = normalizedBackendUrl || fallbackOrigin;

export const API_BASE = `${BACKEND_URL}/api`;

let runtimeToken = null;
let runtimeAdminToken = null;

try {
  runtimeToken = localStorage.getItem("kupidon_token");
  runtimeAdminToken = localStorage.getItem("kupidon_admin_token");
} catch {
  runtimeToken = null;
  runtimeAdminToken = null;
}

const api = axios.create({
  baseURL: API_BASE,
  timeout: 60000,
});

if (runtimeToken) {
  api.defaults.headers.common.Authorization = `Bearer ${runtimeToken}`;
}

api.interceptors.request.use((config) => {
  let token = runtimeToken;
  let adminToken = runtimeAdminToken;
  if (!token) {
    try {
      token = localStorage.getItem("kupidon_token");
    } catch {
      token = null;
    }
  }
  if (!adminToken) {
    try {
      adminToken = localStorage.getItem("kupidon_admin_token");
    } catch {
      adminToken = null;
    }
  }
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const url = config?.url || "";
  if (adminToken && url.startsWith("/admin")) {
    config.headers["X-Admin-Token"] = adminToken;
  }
  return config;
});

export function setToken(token) {
  runtimeToken = token || null;
  if (runtimeToken) {
    api.defaults.headers.common.Authorization = `Bearer ${runtimeToken}`;
  } else {
    delete api.defaults.headers.common.Authorization;
  }
  try {
    if (token) localStorage.setItem("kupidon_token", token);
    else localStorage.removeItem("kupidon_token");
  } catch {
    // Ignore storage failures in restrictive WebView contexts.
  }
}

export function getToken() {
  if (runtimeToken) return runtimeToken;
  try {
    return localStorage.getItem("kupidon_token");
  } catch {
    return null;
  }
}

export function setAdminToken(token) {
  runtimeAdminToken = token || null;
  try {
    if (token) localStorage.setItem("kupidon_admin_token", token);
    else localStorage.removeItem("kupidon_admin_token");
  } catch {
    // Ignore storage failures in restrictive WebView contexts.
  }
}

export function getAdminToken() {
  if (runtimeAdminToken) return runtimeAdminToken;
  try {
    return localStorage.getItem("kupidon_admin_token");
  } catch {
    return null;
  }
}

export default api;
